//mui v5化 完了
import React from 'react'
import { Script } from "gatsby"
import { graphql, useStaticQuery } from 'gatsby'
import urlJoin from 'url-join'
import { StaticImage } from 'gatsby-plugin-image'

import { Avatar, Paper, Grid, Typography, Box, Divider, Link, Tooltip } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person';
import MobileScreenShareOutlinedIcon from '@mui/icons-material/MobileScreenShareOutlined';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';

//socialアイコン用
import { SocialIcon } from 'react-social-icons';

//記事のシェアアイコンを表示するコンポーネント

import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    PocketShareButton,
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon,
    LineShareButton,
    PocketIcon,
    LineIcon,
    HatenaShareButton,
    HatenaIcon,
} from "react-share"




const Share = ({ slug, postTitle, authorId, lightVer }) => {
    const theme = useTheme()
    const CustomTwitterShareButton = styled(TwitterShareButton)({
        margin: theme.spacing(1)
    });
    const CustomFacebookShareButton = styled(FacebookShareButton)({
        margin: theme.spacing(1)
    });
    const CustomLinkedinShareButton = styled(LinkedinShareButton)({
        margin: theme.spacing(1)
    });
    const CustomPocketShareButton = styled(PocketShareButton)({
        margin: theme.spacing(1)
    });
    const CustomLineShareButton = styled(LineShareButton)({
        margin: theme.spacing(1)
    });
    const CustomHatenaShareButton = styled(HatenaShareButton)({
        margin: theme.spacing(1)
    });
    const CustomPaper = styled(Paper)({
        padding: theme.spacing(1),
        marginTop: theme.spacing(2)
    })
    const IconTypoBox = styled(Box)({
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: "100%"
    })

    const data = useStaticQuery(
        graphql`
            query{
                site {
                    siteMetadata {
                        siteUrl
                        title
                        description
                        authors {
                            id
                            twitter
                            name
                            description
                            author_name
                            links {
                                siteName
                                url
                            }
                        }
                    }
                }
            }
        `
    )
    const siteUrl = data.site.siteMetadata.siteUrl
    const articleUrl = urlJoin(siteUrl, slug)
    // const title = data.site.siteMetadata.title サイトのタイトル
    const authors = data.site.siteMetadata.authors
    const iconSize = 32
    const smallIconSize = 26

    // 著者データ取得
    // アイコンデータはstatic/img/author_icons/ツイッターアカウント.jpg
    const filterdAuthor = authors.filter((author) => {
        return author.id === authorId
    })
    let author = filterdAuthor[0]
    if (filterdAuthor.length <= 0) { //authorIDが指定されてなかった場合
        author =
        {
            name: "著者情報なし",
            description: "この記事には著者の情報がありません。",
            links: [],
        }
    }

    if (lightVer) {
        // トップに表示する軽いバージョン

        return (
            <Grid container alignItems="center" justifyContent="flex-end" direction="row">
                <Grid item >
                    <Tooltip title="Twitterでシェア" arrow>
                        {/* メモ：tooltipの中にtitleを含むタグがあるとエラー。spanで囲めば良い。 */}
                        <span>
                            <CustomTwitterShareButton title={postTitle} url={encodeURI(articleUrl)}>
                                <TwitterIcon size={smallIconSize} round />
                            </CustomTwitterShareButton>
                        </span>
                    </Tooltip>
                    <Tooltip title="Facebookでシェア" arrow>
                        <CustomFacebookShareButton url={articleUrl}>
                            <FacebookIcon size={smallIconSize} round />
                        </CustomFacebookShareButton>
                    </Tooltip>

                    <Tooltip title="Linkedinでシェア" arrow>
                        <CustomLinkedinShareButton url={articleUrl}>
                            <LinkedinIcon title={postTitle} size={smallIconSize} round />
                        </CustomLinkedinShareButton>
                    </Tooltip>

                    <Tooltip title="Pocketでシェア" arrow>
                        <CustomPocketShareButton url={articleUrl}>
                            <PocketIcon size={smallIconSize} round />
                        </CustomPocketShareButton>
                    </Tooltip>

                    <Tooltip title="LINEでシェア" arrow>
                        <CustomLineShareButton url={articleUrl} quote={postTitle}>
                            <LineIcon round size={smallIconSize} />
                        </CustomLineShareButton>
                    </Tooltip>

                    <Tooltip title="はてなブックマークでシェア" arrow>
                        <CustomHatenaShareButton url={articleUrl} quote={postTitle}>
                            <HatenaIcon round size={smallIconSize} />
                        </CustomHatenaShareButton>
                    </Tooltip>
                </Grid>
            </Grid >
        )
    } else {
        return (

            <div>
                <CustomPaper variant="outlined">
                    <Script src="https://b.st-hatena.com/js/bookmark_button.js" charset="utf-8" />
                    <IconTypoBox ml={1}>
                        <MobileScreenShareOutlinedIcon sx={{ marginRight: theme.spacing(1) }} />
                        <Typography gutterBottom variant="subtitle1" component="div" >
                            この記事をシェア
                        </Typography>
                    </IconTypoBox>
                    <Divider />
                    <Box mt={1}>
                        <CustomTwitterShareButton title={postTitle} url={encodeURI(articleUrl)}>
                            <TwitterIcon size={iconSize} round />
                        </CustomTwitterShareButton>

                        <CustomFacebookShareButton url={articleUrl}>
                            <FacebookIcon size={iconSize} round />
                        </CustomFacebookShareButton>

                        <CustomLinkedinShareButton url={articleUrl}>
                            <LinkedinIcon title={postTitle} size={iconSize} round />
                        </CustomLinkedinShareButton>

                        <CustomPocketShareButton url={articleUrl}>
                            <PocketIcon size={iconSize} round />
                        </CustomPocketShareButton>

                        <CustomLineShareButton url={articleUrl} quote={postTitle}>
                            <LineIcon round size={iconSize} />
                        </CustomLineShareButton>

                        <CustomHatenaShareButton url={articleUrl} quote={postTitle}>
                            <HatenaIcon round size={iconSize} />
                        </CustomHatenaShareButton>
                    </Box>
                </CustomPaper>

                {/* 著者 */}
                {filterdAuthor.length > 0 &&
                    <CustomPaper variant="outlined">
                        <IconTypoBox ml={1}>
                            <PersonIcon sx={{ marginRight: theme.spacing(1) }} />
                            <Tooltip title={"Twitterにアクセス"}>
                                <Typography gutterBottom variant="subtitle1" component="div">
                                    <Link color="inherit" href={"https://twitter.com/" + author.twitter} >著者</Link>
                                </Typography>
                            </Tooltip>
                        </IconTypoBox>
                        <Divider />
                        <Grid container
                            sx={{ padding: theme.spacing(1) }}
                            direction="row" justifyContent="flex-start" alignItems="center">
                            <Grid item sx={{ marginRight: theme.spacing(3) }} >
                                <Link href={"https://twitter.com/" + author.twitter}>
                                    <Tooltip title={"Twitterにアクセス"}>
                                        <Avatar sx={{ height: 60, width: 60 }}>
                                            {author.twitter === "Neve1074" ? (
                                                <StaticImage
                                                    src="../images/author_icons/small/Neve1074.jpg"
                                                    placeholder="blurred"
                                                    alt="avater"
                                                />
                                            ) : (
                                                <StaticImage
                                                    src="../images/author_icons/small/CrypticToilet.jpg"
                                                    placeholder="blurred"
                                                    alt="avater"
                                                />
                                            )}
                                        </Avatar>
                                    </Tooltip>
                                </Link>
                            </Grid>
                            <Grid item >
                                <Typography variant="subtitle1" component="div">
                                    {/* 著者名 */}
                                    <Link color="inherit" href={"https://twitter.com/" + author.twitter} >
                                        {author.author_name}
                                    </Link>
                                </Typography>
                                <Typography gutterBottom variant="body2" component="div">
                                    {author.description}
                                </Typography>
                                <Box mt={1}>
                                    {
                                        author.links.length > 0 && author.links.map((link, index) =>
                                            <Tooltip title={link.siteName} key={link + index}>
                                                <Box component="span" mr={1} key={author.name + link.siteName} >
                                                    <SocialIcon bgColor="white" url={link.url} style={{ height: "25px", width: "25px" }} />
                                                </Box>
                                            </Tooltip>
                                        )
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </CustomPaper>}
                {/* 著者ここまで */}
            </div >
        )//return
    }

}

export default Share